import { Link, useNavigate } from 'react-router-dom'

import '../assets/styles/components/footer.scss'
import {useDispatch} from "react-redux";
import paymentActions from "../store/actions/payment"

export const Footer = () => {
  const dispatch = useDispatch();
  const footerMenu = [
    {
      id: 0,
      name: 'Products',
      values: [
        { id: 0, name: 'Farm and Ranch' , url: 'products/farm_and_ranch' },
        { id: 1, name: 'Home' , url: 'products/home_owners' },
        { id: 2, name: 'Manufactured and Mobile Home' , url: 'products/manufactured_and_mobile_home' },
        { id: 3, name: 'Landlord' , url: 'products/landlord' },
        { id: 4, name: 'Organization' , url: 'products/organization' }
      ]
    },
    {
      id: 1,
      name: 'About RVOS',
      values: [
        { id: 0, name: 'History of RVOS' , url: '/about/history' },
        { id: 1, name: 'MyRVOS Customer Portal' , url: '/about/my-rvos'},
        { id: 2, name: 'Our Companies' , url: 'about/our-companies' },
        { id: 3, name: 'Newsletter' , url: '/about/newsletter' },
      ]
    },
    {
      id: 2,
      name: 'Info Center',
      values: [
        { id: 0, name: 'Info Center', url: '/info-center' }
      ]
    },
    {
      id: 3,
      name: 'Connection',
      values: [
        { id: 0, name: 'Contact Us', url: '/contact-us' },
        { id: 1, name: 'Find an Agent', url: '/find-an-agent' },
        { id: 2, name: 'Claims', url: '/claims' },
        { id: 3, name: 'Make a Payment', url: '', functionName: 'openPayment' }
      ]
    },
    {
      id: 4,
      name: 'Company',
      values: [
        { id: 0, name: 'Privacy Policy' , url: '/privacy-policy' },
        { id: 1, name: 'Terms of Use' , url: '/terms-of-use' },
        { id: 2, name: 'Careers' , url: '/careers' },
        { id: 3, name: 'Become an Agent' , url: '/careers' },
      ]
    }
  ]

  const footerMenuMobile = [
    {
      id: 0,
      name: 'Products',
      values: [
        { id: 0, name: 'Farm and Ranch' , url: '/' },
        { id: 1, name: 'Homeowners' , url: '/' },
        { id: 2, name: 'Renters' , url: '/' }
      ]
    },
    {
      id: 1,
      name: '.',
      values: [
        { id: 0, name: 'Manufactured Home' , url: '/' },
        { id: 1, name: 'Church and Organization' , url: '/' }
      ]
    },
    {
      id: 3,
      name: 'About RVOS',
      values: [
        { id: 0, name: 'History of RVOS', url: '/about/history' },
        { id: 1, name: 'MyRVOS Customer Portal' , url: 'sign-in'},
        { id: 2, name: 'Our Companies', url: '/about/our-companies' },
        { id: 3, name: 'Newsletter', url: '/about/newsletter' }
      ]
    },
    {
      id: 4,
      name: 'Info Center',
      values: [
        { id: 0, name: 'Info Center', url: '/info-center' }
      ]
    },
    {
      id: 5,
      name: 'Connection',
      values: [
        { id: 0, name: 'Contact Us', url: '/contact-us' },
        { id: 1, name: 'Find an Agent', url: '/find-an-agent' },
        { id: 2, name: 'Claims', url: '/claims' },
        { id: 3, name: 'Make a Payment', url: '', functionName: 'openPayment'}
      ]
    },
    {
      id: 6,
      name: 'Company',
      values: [
        { id: 0, name: 'Privacy Policy' , url: '/privacy-policy' },
        { id: 1, name: 'Terms of Use' , url: '/terms-of-use' }
      ]
    }
  ]

  let navigate = useNavigate();
  const goHome = () => {
    navigate('/')
    window.scrollTo(0,0)
  }
  const linkFunction = (event, name) => {
    if (name === 'openPayment') {
      event.preventDefault();
      dispatch(paymentActions.setPaymentModalOpen(true));
    } else {
      return false;
    }
  }

  const getLink = (link) => {
    if (link.url === 'sign-in') {
      return (
          <a href={process.env.REACT_APP_SIGN_IN_URI || 'https://my.rvos.com/sign/in'} target="_blank" rel="noopener noreferrer">
            {link.name}
          </a>
      )
    } else if (link.name === 'Privacy Policy' || link.name === 'Terms of Use') {
      return (
          <a href={link.url} target="_blank">{link.name}</a>
      )
    } else {
      return (
          <Link to={link.url}
                target={ link.blank && link.blank }
                onClick={(event) => linkFunction(event, link.functionName)}>
            {link.name}
          </Link>
      )
    }
  }
  return (
    <>
      <footer>
        <div className="footer-container">
          <div className="logo-menu-block">

            <div className="block-logo">
              <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/logo2.svg`} alt="" onClick={goHome} />
            </div>
            <div className="block-menu">
              <menu>
                {
                  footerMenu.map((ul) => {
                    return <div className="block-menu__item" key={ul.id}>
                      <div className="block-menu__title">{ul.name}</div>
                      <ul className="block-menu__list">
                        {
                          ul.values.map((value) => {
                            return <li key={value.id}>
                              {getLink(value)}
                            </li>
                          })
                        }
                      </ul>
                    </div>
                  })
                }
              </menu>
            </div>

          </div>

          <div className="block-copyright">
            Copyright © {new Date().getFullYear()} RVOS Insurance. All rights reserved.
          </div>
        </div>
      </footer>
    </>
  );
}
